import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../components/login/LoginForm";
import ForgotPasswordForm from "../components/login/ForgotPasswordForm";
import Footer from "../components/Footer";

const Login = () => {
  const navigate = useNavigate();
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      navigate("/home", { replace: true });
    } else {
      setLoading(false);
    }
  }, [navigate]);

  const handleForgotPasswordClick = () => {
    setFadeOut(true);
    setTimeout(() => {
      setShowForgotPassword(true);
      setFadeOut(false);
    }, 300);
  };

  const handleBackToLogin = () => {
    setFadeOut(true);
    setTimeout(() => {
      setShowForgotPassword(false);
      setFadeOut(false);
    }, 300);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-customBlue"></div>
          <p className="mt-4 text-customBlue font-semibold">Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex flex-col justify-between font-sans bg-cover bg-center bg-no-repeat relative"
      style={{ backgroundImage: "url('/Gráficas web RDS-02.jpg')" }}
    >
      {/* Capa de contraste */}
      <div className="absolute inset-0 bg-slate-900/40" />

      <main className="relative flex-1 w-full mx-auto max-w-7xl px-4 md:px-6 lg:px-10 pt-16 md:pt-24 lg:pt-28 pb-10">
        <div className="mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-stretch">
          {/* IZQUIERDA: Hazte socio */}
          <div className="flex justify-center lg:justify-start">
            <div className="relative w-full max-w-2xl rounded-2xl overflow-hidden shadow-xl border border-white/70">
              {/* degradado */}
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-900/85 via-sky-800/75 to-blue-900/85" />
              {/* textura suave */}
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(255,255,255,0.08),transparent_60%)]" />

              {/* logo superior derecho */}
              <img
                src="/RDS - LOGO VERTICAL-06.png"
                alt="RDS"
                className="absolute top-4 right-4 h-8 opacity-80"
              />

              <section className="relative px-6 sm:px-7 md:px-8 py-7 sm:py-8 text-white">
                <h2 className="mt-3 text-2xl md:text-3xl font-bold leading-tight text-center">
                  ¿Aún no eres parte de CIDERE?
                </h2>

                <p className="mt-3 text-white/90 text-sm md:text-base max-w-xl">
                  Si te interesa ser parte de esta red de empresas e instituciones que buscan aportar al desarrollo
                  de la región de Coquimbo, postula aquí tu ingreso y tendrás acceso a:
                </p>

                <div className="mt-5">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-2">
                      <span className="w-5 h-5 rounded-full bg-emerald-500/90 text-white text-xs flex justify-center items-center flex-shrink-0 mt-0.5">
                        ✓
                      </span>
                      <p className="text-white/95 text-sm">
                        Representación en instancias de relacionamiento con autoridades y participación en Mesas Regionales.
                      </p>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-5 h-5 rounded-full bg-emerald-500/90 text-white text-xs flex justify-center items-center flex-shrink-0 mt-0.5">
                        ✓
                      </span>
                      <p className="text-white/95 text-sm">
                        Acceso preferencial a ruedas de negocios, match empresariales, mentorías, seminarios y capacitaciones generados en alianzas público-privadas.
                      </p>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-5 h-5 rounded-full bg-emerald-500/90 text-white text-xs flex justify-center items-center flex-shrink-0 mt-0.5">
                        ✓
                      </span>
                      <p className="text-white/95 text-sm">
                        Valores exclusivos para ferias, ruedas de negocios y actividades regionales e interregionales donde CIDERE participa como organizador y co-organizador.
                      </p>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-5 h-5 rounded-full bg-emerald-500/90 text-white text-xs flex justify-center items-center flex-shrink-0 mt-0.5">
                        ✓
                      </span>
                      <p className="text-white/95 text-sm">
                        Acceso a RDS (Red de Socios CIDERE), plataforma exclusiva para los socios de CIDERE.
                      </p>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-5 h-5 rounded-full bg-emerald-500/90 text-white text-xs flex justify-center items-center flex-shrink-0 mt-0.5">
                        ✓
                      </span>
                      <p className="text-white/95 text-sm">
                        Visibilidad y difusión en eventos y actividades organizadas o coorganizadas por CIDERE.
                      </p>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-5 h-5 rounded-full bg-emerald-500/90 text-white text-xs flex justify-center items-center flex-shrink-0 mt-0.5">
                        ✓
                      </span>
                      <p className="text-white/95 text-sm"> 
                        Impulsa el desarrollo de talento regional a través de prácticas y tesis alineadas con las necesidades reales del territorio.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="mt-6 flex flex-wrap gap-3 justify-center">
                  <button
                    onClick={() => navigate("/membership/apply")}
                    className="inline-flex items-center justify-center rounded-xl bg-white text-slate-900 font-semibold px-5 h-10 hover:bg-slate-100 active:bg-slate-200 transition"
                  >
                    Hazte socio ahora
                  </button>
                </div>
              </section>
            </div>
          </div>

          {/* DERECHA: Login/Recuperar contraseña */}
          <div className="flex justify-center lg:justify-end">
            <div
              className={`bg-white p-8 rounded-2xl shadow-xl w-full max-w-lg md:max-w-md lg:max-w-xl transition-all duration-300 ease-in-out ${
                fadeOut ? "opacity-0 transform scale-95" : "opacity-100 transform scale-100"
              }`}
              style={{ backgroundColor: "rgba(255,255,255,0.97)" }}
            >
              <div className="flex justify-center mb-6">
                <img
                  src="/RDS - LOGO VERTICAL-01.png"
                  alt="Logo RDS"
                  className="h-28 sm:h-32 mx-auto"
                  style={{ filter: "drop-shadow(0px 2px 3px rgba(0,0,0,0.1))" }}
                />
              </div>

              <h1 className="text-customBlue text-2xl md:text-3xl font-bold text-center mb-8">
                {showForgotPassword ? "Recuperar contraseña" : "Te damos la bienvenida"}
              </h1>

              {showForgotPassword ? (
                <ForgotPasswordForm onBack={handleBackToLogin} />
              ) : (
                <LoginForm onForgotPassword={handleForgotPasswordClick} />
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Login;
